import React, { useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { handleKeyEvents } from 'utils/handlers';

import type { TextAlignment } from 'domains/text_nodes';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';

type TextToolsVerticalAlignProps = {
  value: TextAlignment;
  onClick: (v: TextAlignment) => void;
};

type TextToolsVerticalAlignOptionProps = {
  item: TextAlignment;
  selected: boolean;
  onClick: (v: TextAlignment) => void;
};

const vertAlignMap: Record<TextAlignment, IconProp> = {
  start: 'arrow-up',
  middle: 'compress-alt',
  end: 'arrow-down',
};

const alignItems = Object.keys(vertAlignMap) as TextAlignment[];

function TextToolbarSidebarTextVertical(props: TextToolsVerticalAlignProps) {
  const { value, onClick } = props;
  const buttonContainer = useRef<HTMLDivElement>(null);

  return (
    <div className="texttools-item__text-node text-vertical">
      <span className="screen-reader-text">change text vertical alignment</span>
      <span className="select-vertical">Vertical Text Alignment</span>
      <div className="align-button-container" ref={buttonContainer}>
        {alignItems.map((item) => (
          <TextToolbarSidebarVerticalAlignOption
            key={item}
            item={item}
            selected={item === value}
            onClick={() => onClick(item)}
          />
        ))}
      </div>
    </div>
  );
}

function TextToolbarSidebarVerticalAlignOption({
  item,
  onClick,
  selected = false,
}: TextToolsVerticalAlignOptionProps) {
  return (
    <button
      type="button"
      value={item}
      className={`align-button ${selected ? 'align-button--selected' : ''}`}
      onClick={() => onClick(item)}
      onKeyDown={handleKeyEvents({
        open: () => onClick(item),
        navigate: () => null,
        close: () => null,
      })}
    >
      <FontAwesomeIcon icon={vertAlignMap[item]} title={item} />
    </button>
  );
}

export default TextToolbarSidebarTextVertical;
